import { render } from "./DualButton.vue?vue&type=template&id=17e0e13e&scoped=true"
import script from "./DualButton.vue?vue&type=script&lang=js"
export * from "./DualButton.vue?vue&type=script&lang=js"

import "./DualButton.vue?vue&type=style&index=0&id=17e0e13e&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e0e13e"]])

export default __exports__